module.exports = {
  media: {
    badge: "Тест",
    title: "Пример",
    subtitle: "Тест пример",
    summaryTitle: "Тест",
    summaryText: "Пример",
    summaryPoints: ["Тест", "Пример", "Тест"],
    cardsTitle: "Тест",
    cardsSubtitle: "Пример",
    cards: [
      { icon: "fas fa-photo-film", title: "Тест", text: "Пример" },
      { icon: "fas fa-file-powerpoint", title: "Пример", text: "Тест" },
      { icon: "fas fa-folder-open", title: "Тест", text: "Пример" }
    ],
    listTitle: "Тест",
    listSubtitle: "Пример",
    listItems: ["Тест", "Пример", "Тест"],
    stats: [
      { value: "Тест", label: "Пример" },
      { value: "Пример", label: "Тест" }
    ],
    ctaTitle: "Тест",
    ctaText: "Пример",
    primaryHref: "/pages/contact",
    primaryLabel: "Тест",
    secondaryHref: "/pages/services",
    secondaryLabel: "Пример",
    filterAriaLabel: "Тест",
    modalCloseLabel: "Тест",
    modalTitle: "Пример",
    modalDescription: "Тест",
    filters: [
      { key: "all", label: "Тест", icon: "fas fa-th" },
      { key: "photo", label: "Пример", icon: "fas fa-image" },
      { key: "video", label: "Тест", icon: "fas fa-video" }
    ],
    items: [
      { type: "video", icon: "fas fa-play-circle", placeholder: "Тест", title: "Пример", description: "Тест", badge: "Пример", badgeIcon: "fas fa-video", playLabel: "Тест" },
      { type: "photo", icon: "fas fa-image", placeholder: "Пример", title: "Тест", description: "Пример", badge: "Тест", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Тест", title: "Пример", description: "Тест", badge: "Пример", badgeIcon: "fas fa-video", playLabel: "Тест" },
      { type: "photo", icon: "fas fa-image", placeholder: "Пример", title: "Тест", description: "Пример", badge: "Тест", badgeIcon: "fas fa-image" },
      { type: "photo", icon: "fas fa-image", placeholder: "Тест", title: "Пример", description: "Тест", badge: "Пример", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Пример", title: "Тест", description: "Пример", badge: "Тест", badgeIcon: "fas fa-video", playLabel: "Тест" }
    ]
  }
};